import React, { Component } from "react";
import moment from "moment";

import { dateRenderer, dateSorter, defaultSorter } from "./Helpers";
import UserModel from "./UserModel";

import {
    Table,
    Badge,
    Divider,
    Row,
    Col,
    Card,
    Popconfirm,
    Typography,
    message,
    Tag,
    Tooltip,
} from "antd";

class IntelliportMessagesTable extends Component {
    state = {
        children: [],
    };

    columns = [
        {
            title: "Sériové číslo senozoru",
            dataIndex: "sensor_serial_number",
            key: "sensor_serial_number",
            width: 200,
            sorter: (a, b) =>
                defaultSorter(a.sensor_serial_number, b.sensor_serial_number),
            render: (text, record) => {
                if (record.sensor_serial_number) {
                    return record.sensor_serial_number;
                } else {
                    return "unknown";
                }
            },
        },
        {
            title: "Čas přijetí",
            dataIndex: "received",
            key: "received",
            width: 160,
            defaultSortOrder: "descend",
            sorter: (a, b) => dateSorter(a.received, b.received),
            render: (text, record) => dateRenderer(text),
        },
        {
            title: "Typ zprávy",
            dataIndex: "type",
            width: 130,
            key: "type",
            filters: [
                { text: "Heartbeat", value: "61" },
                { text: "Parking event", value: "62" },
                { text: "Time request", value: "55" },
                { text: "Login", value: "20" },
                { text: "RF Parameters", value: "15" },
                { text: "Firmware request", value: "45" },
                { text: "Parameter list", value: "49" },
                { text: "Syslog upload", value: "57" },
            ],
            onFilter: (value, record) => record.type.indexOf(value) === 0,
            sorter: (a, b) =>
                parseInt(a.type.match(/(\d+)/)) -
                parseInt(b.type.match(/(\d+)/)),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Zpráva",
            dataIndex: "text",
            ellipsis: true,
            key: "text",
            render: (text, record) => {
                // Apply custom styling for the 'Age' column
                const style = {
                    wordBreak: "break-all",
                };

                return <span style={style}>{text}</span>;
            },
        },
    ];

    render() {
        let types = {};

        this.props.data.forEach((item) => {
            if (types[item.text.match(/MT=(\d+)/)] === undefined) {
                item.type = item.text.match(/MT=(\d+)/)[1];
            }
        });

        return (
            <Table
                size="small"
                rowKey={this.props.rowKey ? this.props.rowKey : "id"}
                loading={this.props.loading ? this.props.loading : false}
                columns={this.columns}
                dataSource={this.props.data}
                pagination={{
                    showSizeChanger: true,
                    defaultPageSize:
                        localStorage.getItem("table_pageSize") !== undefined
                            ? parseInt(localStorage.getItem("table_pageSize"))
                            : 10,
                    onShowSizeChange: (current, size) => {
                        localStorage.setItem("table_pageSize", size);
                    },
                }}
                style={{ border: "0px" }}
            />
        );
    }
}

export default IntelliportMessagesTable;



// WEBPACK FOOTER //
// ./src/components/IntelliportMessagesTable.js